const SERVICE_PATH = 'rest/integration-service';
const VERSION = 'v1';
export const IngoApiPath = {
  LeaderBoard: `${SERVICE_PATH}/${VERSION}/leaderboards/ingo`,
};
